import React from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';
import Product from 'components/partials/product';

class ListProductResult extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <section className="list-product-result">
        <div>
          {
            this.props.data.map((item, i) => {
              return (
                <div className="product-wrap" key={i}>
                  <Product enableAddProduct={true} {...item}/>
                </div>
              );
            })
          }
        </div>
      </section>
    );
  }
}

ListProductResult.defaultProps={
  data: []
};

export default ListProductResult;



// WEBPACK FOOTER //
// ./components/list-product/list-product-result/ListProductResult.jsx